import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { KycCountries } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number = 'me') =>
    makeCall<KycCountries>('GET', `/api/v2/user/${userId}/kyc-countries`);
